import useToastStore from '../../store/useToastStore';

export default function Toast() {
  const { message, visible } = useToastStore();
  return <div className={`toast ${visible ? 'on' : ''}`}>{message}</div>;
}
